<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Gift Voucher CTA:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
          ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'GiftVoucherImage')"
            [blockData]="block.variables?.GiftVoucherImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="GiftVoucherImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'GiftVoucherHeading')"
            [blockData]="block.variables?.GiftVoucherHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="GiftVoucherHeading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'GiftVoucherText')"
            [blockData]="block.variables?.GiftVoucherText ?? ''"
            [placeholder]="textPlaceholder"
            variable="GiftVoucherText"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'GiftVoucherImageHref')"
            [blockData]="block.variables?.GiftVoucherImageHref ?? ''"
            [placeholder]="hrefPlaceholder"
            variable="GiftVoucherImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'GiftVoucherImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.GiftVoucherImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'GiftVoucherImageAlt')"
            [blockData]="block.variables?.GiftVoucherImageAlt ?? ''"
            [placeholder]="altPlaceholder"
            variable="GiftVoucherImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'GiftVoucherCtaLink')"
            [blockData]="block.variables?.GiftVoucherCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="GiftVoucherCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'GiftVoucherCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.GiftVoucherCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'GiftVoucherCtaText')"
            [blockData]="block.variables?.GiftVoucherCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            [maxLength]="30"
            variable="GiftVoucherCtaText"
          ></app-block-text>
        </div>
      </div>
    </div>

    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.GiftVoucherImage" class="col-4">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.GiftVoucherImageHref))"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.GiftVoucherImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.GiftVoucherImageAlt)"
              /></a>
          </div>
          <div class="row text-center col-4">
            <div
              class="col-12"
              [innerHTML]="$safeNavigationMigration(block.variables?.GiftVoucherHeading)"
            ></div>
            <div
              class="col-12"
              [innerHTML]="$safeNavigationMigration(block.variables?.GiftVoucherText)"
            ></div>
            <div class="col-12">
              <a
                target="_blank"
                *ngIf="block.variables?.GiftVoucherCtaLink"
                class="btn btn-primary"
                [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.GiftVoucherCtaLink))"
                role="button"
                [innerHTML]="$safeNavigationMigration(block.variables?.GiftVoucherCtaText)"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
